var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected && _vm.selected.length != 0),expression:"selected && selected.length != 0"}],attrs:{"icon":"device_hub","tooltip":"Create new revision"},on:{"click":_vm.createNewRevision}})
}
var staticRenderFns = []

export { render, staticRenderFns }